// extracted by mini-css-extract-plugin
export default {"inputRangeStyles":"pure-input-range_inputRangeStyles__0Sz13"};